import { useTranslation } from 'react-i18next';
import CustomSelect from '../../../Forms/Element/CustomSelect';
import MovementType from './StockMovementType';

/**
 * Componente responsável por listar os tipos de movimentações.
 */
const StockMovementTypeSelect = (props) => {
  
  const { t } = useTranslation();
  const { value, onChange, error } = props;
  const options = [
    { value: MovementType.IN, label: t('in') },
    { value: MovementType.OUT, label: t('out') },
    { value: MovementType.ADJUSTMENT, label: t('adjustment') }
];

  return (
    <CustomSelect options={options} value={value} onChange={onChange} isClearable placeholder={t("select")} error={error}/>
  )
}

export default StockMovementTypeSelect;